import { z } from 'zod'

const freeRoundNotificationTypeSchema = z.literal('freeRound')
const freeRoundStatusSchema = z.enum(['assigned', 'waiting'])
const freeRoundStakeSchema = z.object({
  counter: z.coerce.number(),
  stake: z.coerce.number(),
})

const freeRoundNotificationPayloadSchema = z.object({
  status: freeRoundStatusSchema,
  name: z.string(),
  game: z.string(),
  amount: z.coerce.number(),
  stakes: freeRoundStakeSchema.nullable(),
  validFrom: z.coerce.date(),
  validTo: z.coerce.date(),
  possibleTo: z.coerce.date(),
})

export const freeRoundNotificationSchema = z.object({
  type: freeRoundNotificationTypeSchema,
  payload: freeRoundNotificationPayloadSchema,
})

export type FreeRoundNotification = z.infer<typeof freeRoundNotificationPayloadSchema>
